(() => {
  const initializeCards = (root = document) => {
    root.querySelectorAll('[data-montreal-offer-card]').forEach((card) => {
      if (card.dataset.initialized === 'true') return;
      card.dataset.initialized = 'true';
      const modal = card.nextElementSibling;
      if (!modal || !modal.matches('[data-montreal-offer-modal]')) return;

      const dialog = modal.querySelector('[data-montreal-offer-dialog]');
      const form = modal.querySelector('[data-montreal-offer-form]');
      const formView = modal.querySelector('[data-montreal-offer-form-view]');
      const success = modal.querySelector('[data-montreal-offer-success]');
      const submit = modal.querySelector('[data-montreal-offer-submit]');
      const error = modal.querySelector('[data-montreal-offer-error]');
      const phoneInput = form.querySelector('[data-montreal-phone]');
      let returnFocus = null;

      const normalizeCanadianPhone = (value) => {
        const digits = value.replace(/\D/g, '');
        if (digits.length === 11 && digits.startsWith('1')) return digits.slice(1);
        if (digits.length <= 10) return digits;
        return '';
      };

      const formatCanadianPhone = (value) => {
        const digits = normalizeCanadianPhone(value);
        if (digits.length < 4) return digits;
        if (digits.length < 7) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
        return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
      };

      phoneInput.addEventListener('input', () => {
        phoneInput.value = formatCanadianPhone(phoneInput.value);
        phoneInput.setCustomValidity('');
      });

      phoneInput.addEventListener('paste', (event) => {
        event.preventDefault();
        phoneInput.value = formatCanadianPhone(event.clipboardData.getData('text'));
        phoneInput.dispatchEvent(new Event('input', { bubbles: true }));
      });

      const open = () => {
      returnFocus = document.activeElement;
      formView.hidden = false;
      success.hidden = true;
      modal.hidden = false;
      document.body.classList.add('montreal-offer-open');
      requestAnimationFrame(() => modal.classList.add('is-visible'));
      setTimeout(() => form.elements.name.focus(), 100);
      };
      const close = () => {
      modal.classList.remove('is-visible');
      document.body.classList.remove('montreal-offer-open');
      setTimeout(() => { modal.hidden = true; }, 250);
      if (returnFocus) returnFocus.focus();
      };
      card.querySelector('[data-montreal-offer-open]').addEventListener('click', open);
      modal.querySelectorAll('[data-montreal-offer-close]').forEach((el) => el.addEventListener('click', close));
      document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !modal.hidden) close();
      });

      form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (!form.reportValidity()) return;
      const phone = normalizeCanadianPhone(phoneInput.value);
      if (!/^[2-9]\d{2}[2-9]\d{6}$/.test(phone)) {
        phoneInput.setCustomValidity(dialog.dataset.errorText);
        error.textContent = dialog.dataset.errorText;
        error.hidden = false;
        phoneInput.reportValidity();
        phoneInput.focus();
        return;
      }
      phoneInput.setCustomValidity('');
      error.hidden = true;
      submit.disabled = true;
      submit.textContent = dialog.dataset.processingText;
      const data = Object.fromEntries(new FormData(form).entries());
      data.phone = `+1 ${formatCanadianPhone(phone)}`;
      data.page_url = window.location.href;
      try {
        const response = await fetch(dialog.dataset.endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(data),
        });
        if (!response.ok) throw new Error('Request failed');
        form.reset();
        formView.hidden = true;
        success.hidden = false;
        success.focus();
      } catch (requestError) {
        error.textContent = dialog.dataset.errorText;
        error.hidden = false;
      } finally {
        submit.disabled = false;
        submit.textContent = dialog.dataset.submitText;
      }
      });
    });
  };

  initializeCards();

  const observer = new MutationObserver((mutations) => {
    if (mutations.some((mutation) => mutation.addedNodes.length > 0)) {
      initializeCards();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();
